// get all
export const FLAG_GETTING_PAYMENT_METHODS = 'FLAG_GETTING_PAYMENT_METHODS';
export const SHOW_ERROR_GETTING_PAYMENT_METHODS = 'SHOW_ERROR_GETTING_PAYMENT_METHODS';
export const CLEAR_ERROR_GETTING_PAYMENT_METHODS = 'CLEAR_ERROR_GETTING_PAYMENT_METHODS';
export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS';
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS';
